var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-screen"},[_c('iframe',{staticStyle:{"border":"1px solid rgba(0, 0, 0, 0.1)"},attrs:{"src":_vm.url_map,"width":"100%","height":"100%","allowfullscreen":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }